(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-diamond-carousel"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
      const wrapper = document.querySelector('.hero-section-wrapper');
      if(!wrapper) return;

      const slides = wrapper.querySelectorAll('.carousel-slide');
      const dots = wrapper.querySelectorAll('.dot');
      const nextBtns = wrapper.querySelectorAll('.next-slide');
      const prevBtns = wrapper.querySelectorAll('.prev-slide');
      
      let currentSlide = 0;
      const totalSlides = slides.length;
      let autoPlayInterval; // Variable to store the timer

      if (totalSlides < 2) return; 

      function updateCarousel(index) {
          slides.forEach((slide, i) => slide.classList.toggle('active', i === index));
          dots.forEach((dot, i) => dot.classList.toggle('active', i === index));
          currentSlide = index;
      }

      function nextSlide() { 
        updateCarousel((currentSlide + 1) % totalSlides); 
      }
      
      function prevSlide() { 
        updateCarousel((currentSlide - 1 + totalSlides) % totalSlides); 
      }

      function resetTimer() {
        clearInterval(autoPlayInterval);
        autoPlayInterval = setInterval(nextSlide, 5000);
      }

      // Button Listeners
      nextBtns.forEach(btn => btn.addEventListener('click', () => {
        nextSlide();
        resetTimer();
      }));
      
      prevBtns.forEach(btn => btn.addEventListener('click', () => {
        prevSlide();
        resetTimer();
      }));
      
      dots.forEach((dot, idx) => {
          dot.addEventListener('click', () => {
            updateCarousel(idx);
            resetTimer();
          });
      });

      // --- NEW: SWIPE LOGIC ---
      let touchStartX = 0;
      let touchEndX = 0;

      wrapper.addEventListener('touchstart', e => {
          // Record where the touch started
          touchStartX = e.changedTouches[0].screenX;
      }, {passive: true});

      wrapper.addEventListener('touchend', e => {
          // Record where the touch ended
          touchEndX = e.changedTouches[0].screenX;
          handleGesture();
          resetTimer(); // Reset auto-play when user swipes manually
      }, {passive: true});

      function handleGesture() {
          const threshold = 50; // Minimum distance (px) to count as a swipe
          
          // Swipe Left (Show Next)
          if (touchStartX - touchEndX > threshold) {
              nextSlide();
          }
          
          // Swipe Right (Show Prev)
          if (touchEndX - touchStartX > threshold) {
              prevSlide();
          }
      }
      // ------------------------

      // Initialize Auto play
      autoPlayInterval = setInterval(nextSlide, 5000);
  });

  } catch(e) { console.error(e); }
})();
})();
